module.exports = __webpack_public_path__ + "static/media/web_logo01.265c6421.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/web_logo01.png
// module id = 1043
// module chunks = 12